import React, { useState, useEffect } from 'react';
import { setUserInfoToSession, getUserInfoFromSession } from '../Services/session.mgmt';
import { useNavigate } from 'react-router-dom';
import Button from '../Components/Button/Button';

const MockUserInfo = () => {
  const [userInfo, setUserInfo] = useState(
    getUserInfoFromSession() || {
      userid: '',
      countryCd: '',
      sitecode: '',
      isExternal: false,
      isAdmin: false,
      rdnInd: 0,
      hasContractProfile: false,
      cntrctrNb: '',
    }
  );
  const nav = useNavigate();

  useEffect(() => {
    const storedUserInfo = getUserInfoFromSession();
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserInfo({
      ...userInfo,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserInfoToSession(userInfo);
    const navToPath = document.getElementsByName('navtopath')[0].value;
    if (navToPath) {
      nav(navToPath);
    } else {
      nav('/');
    }
  };

  return (
    <section className="form-demo">
      <form onSubmit={handleSubmit} className="faq-search fmc-mb-4">
        <div>
          <label htmlFor="userid">User ID:</label>
          <input type="text" name="userid" id="userid" value={userInfo.userid} onChange={handleChange} />
        </div>
        <div>
          <label htmlFor="countryCd">Country Code:</label>
          <input type="text" name="countryCd" id="countryCd" value={userInfo.countryCd} onChange={handleChange} />
        </div>
        <div>
          <label htmlFor="sitecode">Site Code:</label>
          <input type="text" name="sitecode" id="sitecode" value={userInfo.sitecode} onChange={handleChange} />
        </div>
        <div>
          <label htmlFor="isExternal">Is External:</label>
          <input
            type="checkbox"
            name="isExternal"
            id="isExternal"
            checked={userInfo.isExternal}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="isAdmin">Is Admin:</label>
          <input type="checkbox" name="isAdmin" id="isAdmin" checked={userInfo.isAdmin} onChange={handleChange} />
        </div>
        <div>
          <label htmlFor="rdnInd">rdnInd:</label>
          <input type="text" name="rdnInd" id="rdnInd" value={userInfo.rdnInd} onChange={handleChange} />
        </div>
        <div>
          <label htmlFor="navtopath">to path:</label>
          <input type="text" name="navtopath" id="navtopath" />
        </div>
        <div>
          <label htmlFor="hasContractProfile">Has Contract Profile:</label>
          <input
            type="checkbox"
            name="hasContractProfile"
            id="hasContractProfile"
            checked={userInfo.hasContractProfile}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="cntrctrNb">Contractor Number:</label>
          <input type="text" name="cntrctrNb" id="cntrctrNb" value={userInfo.cntrctrNb} onChange={handleChange} />
        </div>
        <Button label="Update" onClick={handleSubmit} />
      </form>
    </section>
  );
};

export default MockUserInfo;
